import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "rnd-helmet";

function Homepage({staticContext, match}) {
  let initialData = {};
  if (staticContext && staticContext.data) {
    initialData = staticContext.data;
  }

  const [state, setState] = useState(initialData);
  useEffect(() => {
    if (window.__ROUTE_DATA__) {
      setState(window.__ROUTE_DATA__);
      delete window.__ROUTE_DATA__;
    }
    else {
      const callback = require('@Callbacks/apiTestResults');
      setState(callback({}, match));
    }
  }, []);

  // Load the routes for the specific country.
  const routesCore = require(`../../../config/core/client.routes.json`);
  const routesOpCo = require(`../../../config/${process.env.REACT_APP_COUNTRY}/client.routes.json`);
  const routes = {
    ...routesCore,
    ...routesOpCo
  };
  const lang = process.env.REACT_APP_DEFAULT_LANGUAGE;

  return(
    <>
      <Helmet>
        <header className="header header--text bg-variant-brand-secondary" />
      </Helmet>
      <div>
        <div><Link to={routes[lang]['our-offices']['url'].replace(":searchParams*", "")}>Our offices</Link></div>
      </div>
    </>
  )
}

export default Homepage;
